import {
  Dna,
  TestTubes,
  Leaf,
  HeartPulse,
  Microscope,
  UserRound,
} from "lucide-react";

export const Infertility = [
  {
    id: 101,
    title: "Embryo Preservation",
    slug: "embryo-preservation",
    parentSlug: "female-infertility",
    category: "female-infertility",
    shortDescription:
      "Expert care in preserving embryos to safeguard your future parenthood plans.",
    icon: Dna,
  },
  {
    id: 102,
    title: "IUI Treatment",
    slug: "iui-treatment",
    parentSlug: "female-infertility",
    category: "female-infertility",
    shortDescription:
      "Intrauterine insemination treatment for couples struggling with conception.",
    icon: TestTubes,
  },
  {
    id: 103,
    title: "Blastocyst Transfer",
    slug: "blastocyst-transfer",
    parentSlug: "female-infertility",
    category: "female-infertility",
    shortDescription:
      "High-success embryo transfer at the blastocyst stage to improve pregnancy chances.",
    icon: Leaf,
  },
  {
    id: 104,
    title: "Assisted Embryo Hatching",
    slug: "assisted-embryo-hatching",
    parentSlug: "female-infertility",
    category: "female-infertility",
    shortDescription:
      "Advanced embryo hatching techniques to increase implantation success.",
    icon: Dna,
  },
  {
    id: 105,
    title: "PCOD / PCOS Treatment",
    slug: "pcod-pcos-treatment",
    parentSlug: "female-infertility",
    category: "female-infertility",
    shortDescription:
      "Personalized treatments to restore hormonal balance and improve fertility.",
    icon: HeartPulse,
  },
  {
    id: 106,
    title: "ICSI Treatment",
    slug: "icsi-treatment",
    parentSlug: "female-infertility",
    category: "female-infertility",
    shortDescription:
      "Intracytoplasmic sperm injection for complex infertility cases.",
    icon: Microscope,
  },
  {
    id: 107,
    title: "IVF Treatment",
    slug: "ivf-treatment",
    parentSlug: "female-infertility",
    category: "female-infertility",
    shortDescription:
      "Advanced IVF programs designed to maximize pregnancy success rates.",
    icon: UserRound,
  },
];
